module.exports = __webpack_public_path__ + "static/media/icon-close.6ea8ab27.svg";